module.exports = __webpack_public_path__ + "static/img/robot.8496fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot.png
// module id = zx9P
// module chunks = 1